export default {
  applet: {
    title: "小程序列表",
    appName: "应用名称",
    appId: "应用Id",
    singleStore: "单门店",
    multiStore: "多门店",
  },
  auth: {
    title: "用户渠道授权",
    storeMode: "门店模式",
    pluginAuth: "增值插件授权",
    userChannel: "用户端：",
    selectMode: "选择模式：",
  },
  empower: {
    title: "授权详情",
    siteId: "站点ID",
    authorized: "已授权",
    unauthorized: "未授权",
    expired: "已到期",
    accountLimit: "可创建账号数量",
    serviceType: "服务类型",
    authStatus: "授权状态",
    unlimited: "无限",
    siteUrl: "网站URL",
    siteUrlPh: "网站url",
    siteIp: "站点IP",
    siteIpPh: "站点IP",
    authCode: "授权码",
    authCodePh: "授权码",
    authCodeTip:
      "温馨提示：如授权码失效，请将网站域名以及站点ID提交给客服；请保护好您的授权码，避免泄露",
    expireTime: "到期时间",
    expireTimePh: "到期时间",
  },
  edit: {
    shopNumLabel: "可创建门店数量：",
    shopNumPh: "请输入可创建门店数量",
    unlimited: "无限",
    appPluginAuth: "应用插件授权",
    appPlugin: "应用插件：",
    valuePluginAuth: "增值插件授权",
    valuePlugin: "增值插件：",
    otherPerm: "其他权限设置",
    serviceQq: "客服QQ",
    serviceQqPh: "请输入客服QQ",
    headerLogo: "网站头部LOGO",
    sizeTip: "建议尺寸：720*180",
    copyright: "版权文字",
    copyrightPh: "请输入版权文字",
    copyrightTip: "此处版权文字显示页面底部",
    deliveryName: "码科配送名称",
    deliveryNamePh: "码科配送名称",
    deliveryNameTip: "自定义码科配送名称",
    superAuthName: "超级权限",
  },
  cache: {
    title: "缓存设置",
    redisPwd: "Redis密码",
    redisPwdPh: "请输入Redis密码",
    redisPwdTip: "请输入Redis密码,Redis密码请在您的服务器扩展里面查询",
    tip: "提示",
    redisPort: "redis端口",
    redisPortPh: "请输入redis端口",
    redisPortTip: "端口默认为6379",
    swoolePort: "Swoole端口",
    swoolePortPh: "请输入Swoole端口",
    swoolePortTip:
      "请先在阿里云或腾讯云或其他云服务器厂商后台开放9875端口，然后在宝塔控制面板开放9875端口",
    sslCert: "ssl_certificate",
    sslCertPh: "请输入ssl_certificate",
    sslCertTip: "请填写ssl_certificate证书路径",
    sslCertKey: "ssl_certificate_key",
    sslCertKeyPh: "请输入ssl_certificate_key",
    sslCertKeyTip: "请填写ssl_certificate_key证书路径",
    dialogTitle: "操作提示",
    redisStep1:
      "第一步：进入宝塔控制面板，点击软件商店，搜索redis，如果没有安装此扩展请先安装",
    redisStep2:
      "第二步：点击设置，点击性能调整，设置redis密码，并将redis密码保存在下方即可，注意：密码请勿随便修改",
    swooleStep1:
      "第一步：去阿里云或腾讯云或其他云服务器厂商后台-安全组策略开放9875端口，保存即可",
    swooleStep2: "第二步：然后在宝塔控制面板开放9875端口，保存即可",
    sslStep1:
      "进入宝塔控制面板，点击网站-站点设置-配置文件，找到以下ssl证书路径依次填写到下方，保存即可",
    detect: "检测",
  },
};
